import React from 'react';
import { Modal, Button } from 'reactstrap';
import { FormInfoAnalyte } from './FormInfoAnalyte';
import { DeleteInfoAnalyte } from './DeleteInfoAnalyte';
import { Dialog } from 'primereact/dialog';

export const ModalInfoAnlyte = (props) => {

    const {
        modal, modalTitle, toggle, method,
        validaciones,
        name, code, is_interfaced,
        handleInputChange, loading,
        saveCreate, saveUpdate, is_analyte = true
    } = props;

    return (
        <Dialog
            visible={modal}
            modal
            closable={false}
            appendTo={document.body}
            onHide={toggle}
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="fa fa-gear"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {modalTitle}
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v22`}
            footer={
                <>
                    {
                        method === "create" &&
                        <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveCreate}
                        >
                            {is_analyte ? "Crear analito" : "Crear caracteristica"}
                        </Button>
                    }

                    {
                        method === "update" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveUpdate}
                        >
                            {is_analyte ? "Editar analito" : "Editar caracteristica"}
                        </Button>
                    }
                    <Button
                        color="danger"
                        size="sm"
                        className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                        onClick={toggle}
                    >
                        Cancelar
                    </Button>

                </>
            }

        >
            {
                method === "create"
                    ? <FormInfoAnalyte
                        button={is_analyte ? "Crear analito" : "Crear caracteristica"}
                        {...{ toggle, loading, handleInputChange, validaciones, methodAction: saveCreate, name, code, is_interfaced, is_analyte, method }}
                    />
                    : (method === "update")
                        ? <FormInfoAnalyte
                            button={is_analyte ? "Editar analito" : "Editar caracteristica"}
                            {...{ toggle, loading, handleInputChange, validaciones, methodAction: saveUpdate, name, code, is_interfaced, is_analyte, method }}
                        />
                        : <DeleteInfoAnalyte
                        />
            }
        </Dialog>
    )
};
